const CONSTANT = {
    eventsListners: {
        DOMLOADED: "DOMContentLoaded",
        LOAD: "load",
        SCROLL: "scroll",
        CLICK: "click",
        KEYUP: "keyup",
        KEYPRESS: "keypress",
        KEYDOWN: "keydown",
        MOUSEOVER: "mouseover",
        MOUSELEAVE: "mouseleave",
        HOVER: "hover",
        BLUR: "blur",
        CHANGE: "change",
        PASTE:"paste",
        INPUT:'input',
        FOCUS:'focus',
        DOUBLECLICK: "dblclick",
        SUBMIT: "submit",
        WINDOW: window,
        RESIZE: "resize",
        BSMODALSHOW: "show.bs.modal",
        BSMODALSHOWN: "shown.bs.modal",
        BSMODALHIDE: "hide.bs.modal",
        BSMODALHIDDEN: "hidden.bs.modal",
        BSALERTCLOSE: "close.bs.alert",
        BSALERTCLOSED: "closed.bs.alert",
        BSCAROUSELSLIDE: "slid.bs.carousel",
        slideChange: "slideChange",
        beforeTransitionStart: "beforeTransitionStart",
        slideChangeTransitionEnd: "slideChangeTransitionEnd",
    },
    breakpoints: {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
    },
    videoOption: {
        tooltips: {
            controls: true,
        },
        muted : false,
        volume: 0.5,
        controls: [
            'play-large', // The large play button in the center
            // 'restart', // Restart playback
            'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'captions', // Toggle captions — Plyr only shows it when the video has a <track> (WCAG 1.2.2)
            // 'settings', // Settings menu
            // 'pip', // Picture-in-picture (currently Safari only)
            // 'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen', // Toggle fullscreen
          ],
        // loadSprite: false,
        // iconUrl: "/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg",
        // iconPrefix: "video-control",
        // Captions start off; viewers turn them on with the CC button
        captions: { active: false, language: "auto", update: true },
        fullscreen: { iosNative: true, enabled: true },
        // Plyr hides YouTube's own controls (incl. its CC button), so ask
        // YouTube to show the video's captions by default (WCAG 1.2.2).
        youtube: { showinfo: 0, rel: 0, modestbranding: 1, cc_load_policy: 1, cc_lang_pref: "en" },
    },
};

export default CONSTANT;
